import script from "./numberScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./numberScroll.vue?vue&type=script&setup=true&lang=js"

import "./numberScroll.vue?vue&type=style&index=0&id=6426c6b4&lang=scss"

const __exports__ = script;

export default __exports__